'use client';

import { useIsDesktop } from '@/shared/lib/react/useIsDesktop';
import { CheckBox, CustomButton } from '@/shared/ui/atoms';

interface ConsultSubmitProps {
  isAgreed: boolean;
  onAgreedChange: (isAgreed: boolean) => void;
  onSubmit: () => void;
}

const ConsultSubmit = ({ isAgreed, onAgreedChange, onSubmit }: ConsultSubmitProps) => {
  const isDesktop = useIsDesktop();
  return (
    <div className="w-full pb-[3.7rem] md:pb-0 md:w-auto relative flex items-center justify-between gap-[0.5rem]">
      <div className="flex items-center gap-[0.5rem]">
        <CheckBox
          id="isAgreed"
          checked={isAgreed}
          width={18}
          height={18}
          uncheckedBgColor="white"
          checkedColor="#6B00D7"
          border={{ color: '#E5E7EF', borderWidth: '1px', radius: '4px' }}
          onChange={onAgreedChange}
        />
        <label htmlFor="isAgreed" className="text-[1rem] leading-[1.25rem] text-[#808284]">
          입력한 정보로<span className="text-[#070D19] leading-[1.31rem]"> 서비스 안내</span>를 받을게요.
        </label>
      </div>
      <div className="fixed bottom-0 left-0 md:relative w-full bg-white p-[1rem] md:w-fit md:p-0 z-[2]">
        <CustomButton
          disabled={!isAgreed}
          className="w-full py-[0.72rem] md:w-[11.28rem] md:py-[0.88rem] md:px-0 text-[1rem] font-medium leading-[1.25rem] text-[#F0F2F7] rounded-[0.63rem]"
          style={{ backgroundColor: !isAgreed ? '#E5E7EF' : '#5025EB' }}
          onClick={onSubmit}
        >
          {isDesktop ? '상담 신청하기' : '신청하기'}
        </CustomButton>
      </div>
    </div>
  );
};

export default ConsultSubmit;
